import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Badge extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    width: PropTypes.number,
  }

  render() {
    const { color, width, children } = this.props
    const badgeStyle = {
      backgroundColor: color || '#C05136',
      width: width,
    }

    return (
      <div style={badgeStyle} className={styles.badge}>
        {children}
      </div>
    )
  }
}
